/**
 * Shared compact mapping layout used by Automation configuration surfaces and
 * their on-canvas summaries. Keep row density in one place so both views stay
 * visually identical.
 */
export const STREAMLAIN_MAPPING_GRID_LAYOUT = {
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  minWidth: 0,
} as const;

export const STREAMLAIN_MAPPING_HEADER_LAYOUT = {
  display: 'grid',
  gap: 6,
  padding: '4px 0',
} as const;

export const STREAMLAIN_MAPPING_ROW_HEIGHT = 32;

export const STREAMLAIN_MAPPING_ROW_LAYOUT = {
  display: 'grid',
  gap: 6,
  alignItems: 'center',
  minWidth: 0,
  minHeight: STREAMLAIN_MAPPING_ROW_HEIGHT,
  padding: '4px 0',
  boxSizing: 'border-box',
} as const;

export const STREAMLAIN_TYPE_CHIP_LAYOUT = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  minHeight: 18,
  padding: '1px 4px',
  borderRadius: 2,
  fontSize: 10,
  fontWeight: 500,
  lineHeight: '16px',
  boxSizing: 'border-box',
  color: 'white',
  textTransform: 'uppercase',
} as const;
